import React, { Component, useEffect, lazy, Suspense } from 'react';
import Default from "../../Layout/Default";
import Auth from '../../Layout/Auth';
import { Routes, Route } from "react-router-dom";
import LoginPage from '../Pages/SignIn';
import ForgotPassword from '../Pages/ForgotPassword';
import SignUp from '../Pages/SignUp';
import FixturesHistory from '../../Modules/Fixtures/FixturesHistory';
import FixturesPlayersDetails from '../../Modules/Fixtures/FixturesPlayersDetails';
import Luminaires from '../../Modules/Luminaires/Luminaires';
import Dashboard from '../../Modules/Dashboard/Dashboard';


function LoginRoute() {

    console.log('LoginRoute Entry')
    return (
        <Routes>
            {/* app landing page route */}
            <Route
                path="/"
                element={
                    <Default >
                        <LoginPage />
                    </Default>
                }
            />

            {/* login route */}
            <Route
                path="login"
                element={
                    <Default >
                        <LoginPage />
                    </Default>
                }
            />

            {/* sign up route */}
            <Route
                path="sign-up"
                element={
                    <Default >
                        <SignUp />
                    </Default>
                }
            />

            {/* forget password route */}
            <Route
                path="forgot_password/:type?"
                element={
                    <Default >
                        <ForgotPassword />
                    </Default>
                }
            />

            {/* fixtures routes */}
            <Route
                path="fixtures/history"
                element={
                    <Auth>
                        <FixturesHistory />
                    </Auth>
                }
            />
            <Route
                path="fixtures/players/:id?"
                element={
                    <Auth>
                        <FixturesPlayersDetails />
                    </Auth>
                }
            />

            {/* luminaires */}
            <Route
                path="luminaires"
                element={
                    <Auth>
                        <Luminaires />
                    </Auth>
                }
            />

            {/* dashboard */}
            <Route
                path="dashboard"
                element={
                    <Auth>
                        <Dashboard />
                    </Auth>
                }
            />
        </Routes>
    );

}
export default LoginRoute;
